import ClassNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import { getIsHeaderWithFixedSidebar } from "../selectors/modules.js";
import { getActiveSite } from "../selectors/sites.js";
import { useAppSelector } from "../store/hooks.js";
import styles from "../stylesheets/components/site-inner.module.css";
import { getDynamicTitleFontsCSS } from "../utils/dynamicFonts.js";
import { css } from "../utils/emotion.js";

interface Props {
  isPreview: boolean;
  children: ReactNode;
}

const SiteInner: FunctionComponent<Props> = ({ isPreview, children }) => {
  const site = useAppSelector((state) => getActiveSite(state.sites));
  const fonts = useAppSelector((state) => state.fonts);
  const isHeaderWithSidebar = useAppSelector((state) =>
    getIsHeaderWithFixedSidebar(state.modules),
  );
  const dynamicFontRules = getDynamicTitleFontsCSS({ site, isPreview, fonts });
  const isLightFont = useAppSelector(
    (state) =>
      state.fonts.byFamily[site.fontFamily]?.variants.some(
        ({ weight }) => weight === "300",
      ) ?? false,
  );

  return (
    <div
      className={ClassNames(
        styles.SiteInner,
        {
          [styles["SiteInner--with-sidebar"]]: isHeaderWithSidebar,
          [styles["SiteInner--light-font"]]: isLightFont,
        },
        css(dynamicFontRules),
      )}
    >
      {children}
    </div>
  );
};

export default SiteInner;
